export const validateEmail = (email: string) => {
  const REGEX = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
  return REGEX.test(email);
};
